<app-modal-header (closeModal)="close()"></app-modal-header>
@defer (when products.data.length > 0 && !isShowTabPlaceholder) {
  <app-modal-body>
    <div class="row mb-3">
      <div class="col-12">
        <h1 class="fs-5">{{ 'PRODUCT_INQUIRY' | translate }}</h1>
        <p class="fw-medium">{{ 'CHOOSE_THE_PRODUCTS_THAT_YOU_WOULD_LIKE_TO_INQUIRE_ON' | translate }}</p>
      </div>
    </div>
    <div class="row">
      @for (item of products.data; track $index; let i = $index) {
        <div class="col-3" tabindex="0" (click)="selectProduct(item, i)" (keydown.space)="selectProduct(item, i)">
          <ng-template #cardProducts></ng-template>
        </div>
      }
    </div>
  </app-modal-body>
  <app-modal-footer classList="d-flex justify-content-center">
    <button
      type="button"
      class="btn btn-primary rounded-5"
      (click)="sendProductInquiry()"
      [disabled]="isHttpRequestRunning"
    >
      @if (isHttpRequestRunning && activeButton === ActiveButton.SEND_PRODUCT_INQUIRY) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      }
      {{ 'SEND' | translate }}
    </button>
  </app-modal-footer>
} @placeholder {
  @if (isShowTabPlaceholder) {
    <app-modal-body>
      <app-skeleton-modal-product-inquiry-via-exhibitor />
    </app-modal-body>
  } @else {
    <p class="fw-medium mb-0 text-center mb-4">{{ 'NO_DATA_AVAILABLE' | translate }}</p>
  }
}
